import React, { createContext, useState } from "react";

export const demoContext = createContext();

export const DemoProvider = (props) => {
  const orgId = "a69c754c-c1d6-4ac1-9687-3e58e9b6324f";

  const token =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYyZTliZDE4N2RlMDdhMDAwNDExYzcwYSIsInBsYW4iOiJmcmVlIiwidmVyaWZpZWQiOnRydWUsImZpcnN0TmFtZSI6IlNoYW1tYWgiLCJsYXN0TmFtZSI6Ik5laSIsImVtYWlsIjoic2hhbW1haEBwaGlsYW50aHJvbGFiLmNvIiwiY3JlYXRlZEF0IjoiMjAyNS0wMS0xNVQxMDo0MDo1Ny4wMzRaIiwidXBkYXRlZEF0IjoiMjAyNS0wMS0xNVQxMDo0MDo1Ny4wMzRaIiwiaWF0IjoxNzM4MDYzMjk1LCJleHAiOjE3NDY3MDMyOTUsInN1YiI6IjYyZTliZDE4N2RlMDdhMDAwNDExYzcwYSJ9.IiBr_I3nXWdTylk7rLZvmv7u2rJRVCnrfPaw1-TAjWA";

  // Org details
  const [organization] = useState({
    id: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
    description:
      "We are committed to the native and indigenous women, helping them get opportunities that should be utilized, securing jobs, training, scholarships and healthcare.",
    name: "Atewo Women",
    tagline: "The native crown",
    alternateName: "Building a sure foundation for women in the locality.",
    email: "tarablake@email.co",
    url: "https://atewowomen.org",
    ein: null,
    deductibility: null,
    subsection: null,
    assetAmount: null,
    nteeType: "Community Improvement, Capacity Building",
    incomeAmount: null,
    nteeSuffix: "81",
    filingRequirement: null,
    classification: null,
    latest990: null,
    rulingDate: null,
    nteeCode: "S81",
    groupName: null,
    deductibilityCode: null,
    affiliation: null,
    foundationStatus: null,
    nteeClassification: "Women's Service Clubs",
    accountingPeriod: null,
    exemptOrgStatus: null,
    deductibilityDetail: null,
    exemptOrgStatusCode: null,
    subOpCategory: "Skills & Training",
    opCategory: "work",
    nteeLetter: "S",
    reviews: null,
    rating: null,
    logoUrl: null,
    programs: null,
    services: null,
    contacts: null,
    locations: null,
    phones: null,
  });

  // services

  const [services] = useState([
    {
      id: "360631b0-c452-454d-8cfd-b8b7bf5b7292",
      orgId: null,
      name: "#IDareYouToCare, Mon - Fri Food Pantry",
      status: "Open",
      alternateName: "",
      description:
        "   Provides food, clothes, school supplies, hygiene products, household cleaning products to the homeless or low income individuals.   ",
      url: "http://www.lunchboxoflove.org",
      email: "love@lunchboxoflove.org",
      interpretationServices: "",
      applicationProcess: "",
      waitTime: null,
      cost: null,
      accreditations: "",
      licenses: "",
      subOpCategory: "",
      opCategory: "Food",
      requiredDocuments:
        "Driver's License or ID, Passport, Referral Letter, utility bill, Lease, or Caseworker request letter",
      paymentsAccepted: "",
      eligibilities: "Open to anyone in the service area  ",
      fundings: "",
      serviceAreas: "Tarrant County ",
      languages: "English",
      draft: null,
      isPublished: null,
      createdAt: null,
      updatedAt: null,
      overallCapacity: null,
      currentlyServing: null,
      autoScreen: null,
      program: null,
      organization: null,
      location: null,
      contacts: null,
      phones: null,
      referrals: null,
    },
    {
      id: "71f18db7-539c-4780-9f1a-be8f3889b2a4",
      orgId: null,
      name: "1-800-RUNAWAY",
      status: "Open",
      alternateName: "",
      description:
        "Serves as a hotline that provides crisis intervention, information and referral, message relay, conflict mediation, conference calling, runaway education, and prevention materials. Youth and family members can call, text, or chat 24 hours a day to work through problems and find local help from social service agencies and organizations.",
      url: "http://www.1800runaway.org",
      email: "info@1800runaway.org",
      interpretationServices: "",
      applicationProcess: "",
      waitTime: null,
      cost: null,
      accreditations: "",
      licenses: "",
      subOpCategory: "",
      opCategory: "Emergency",
      requiredDocuments: "Call, text, email, or chat for information",
      paymentsAccepted: "",
      eligibilities:
        "Youth who have run away, are thinking about running away, or are in crisis; parents whose child has run from home or are struggling with their child; other concerned individuals ",
      fundings: "",
      serviceAreas: "Nationwide",
      languages: "English, Spanish, Language Line for other languages",
      draft: null,
      isPublished: null,
      createdAt: null,
      updatedAt: null,
      overallCapacity: null,
      currentlyServing: null,
      autoScreen: null,
      program: null,
      organization: null,
      location: null,
      contacts: null,
      phones: null,
      referrals: null,
    },
    {
      id: "25560c8c-e91b-4567-a58d-4164a20cc1e6",
      orgId: null,
      name: "1st Sat Mobile Food Pantry",
      status: "Open",
      alternateName: "",
      description: "Provides a mobile food pantry for Wise County residents.",
      url: "https://www.decaturmethodist.org/",
      email: "info@decaturmethodist.org",
      interpretationServices: "",
      applicationProcess: "",
      waitTime: null,
      cost: null,
      accreditations: "",
      licenses: "",
      subOpCategory: "",
      opCategory: "Food",
      requiredDocuments: "Driver's license, ID, or utility bill",
      paymentsAccepted: "",
      eligibilities:
        "Remains OPEN during COVID-19: Open to individuals residing in Wise County  ",
      fundings: "",
      serviceAreas: "Wise County ",
      languages: "English ",
      draft: null,
      isPublished: null,
      createdAt: null,
      updatedAt: null,
      overallCapacity: null,
      currentlyServing: null,
      autoScreen: null,
      program: null,
      organization: null,
      location: null,
      contacts: null,
      phones: null,
      referrals: null,
    },
    {
      id: "fb031b9c-d3c2-4491-9651-4a760c773885",
      orgId: null,
      name: "1st Wed Mobile Food Pantry",
      status: "Open",
      alternateName: "",
      description:
        "Administers mobile food pantry on the first Wednesday of each month from 9:00 am until food is distributed. Food includes fresh food and refrigerated items as available and is distributed directly to the public in an outdoor setting. Participants are asked to bring enough bags to carry away approx. 35-45 lbs. of food.",
      url: "http://www.arlingtonurbanministries.org",
      email: "a_u_m@sbcglobal.net",
      interpretationServices: "",
      applicationProcess: "",
      waitTime: null,
      cost: null,
      accreditations: "",
      licenses: "",
      subOpCategory: "",
      opCategory: "Food",
      requiredDocuments: "Picture ID",
      paymentsAccepted: "",
      eligibilities: "Open to anyone in the service area ",
      fundings: "",
      serviceAreas:
        "Erath, Hood, Johnson, Palo Pinto, Parker, Somervell, Tarrant, and Wise Counties ",
      languages: "English",
      draft: null,
      isPublished: null,
      createdAt: null,
      updatedAt: null,
      overallCapacity: null,
      currentlyServing: null,
      autoScreen: null,
      program: null,
      organization: null,
      location: null,
      contacts: null,
      phones: null,
      referrals: null,
    },
    {
      id: "8d917fd9-18f0-4a6d-bb2a-7727208b53b8",
      orgId: null,
      name: "1st and 3rd Sat Food Pantry",
      status: "Open",
      alternateName: "",
      description:
        "Provides emergency food in form of canned goods and dried food items; no meat products at this location; also includes limited personal grooming items",
      url: "http://www.foresthillsda.org",
      email: "",
      interpretationServices: "",
      applicationProcess: "",
      waitTime: null,
      cost: null,
      accreditations: "",
      licenses: "",
      subOpCategory: "",
      opCategory: "Food",
      requiredDocuments:
        "Government issued Photo ID, proof of address, and proof of income.",
      paymentsAccepted: "",
      eligibilities:
        "Remains OPEN during COVID-19: Open to individuals that must meet income limits - 185% of federal poverty ",
      fundings: "",
      serviceAreas: "Tarrant County",
      languages: "English, Spanish (on request)",
      draft: null,
      isPublished: null,
      createdAt: null,
      updatedAt: null,
      overallCapacity: null,
      currentlyServing: null,
      autoScreen: null,
      program: null,
      organization: null,
      location: null,
      contacts: null,
      phones: null,
      referrals: null,
    },
    {
      id: "cd74aa56-b618-4c7e-8248-e836f0695838",
      orgId: null,
      name: "1st, 3rd, and 5th Mon Food Pantry",
      status: "Open",
      alternateName: "",
      description:
        "Operates a food pantry on Mondays for residents needing one time assistance in designated area. Assistance given once every six months per household. ",
      url: "http://www.firsteverman.org",
      email: "church@firsteverman.org",
      interpretationServices: "",
      applicationProcess: "",
      waitTime: null,
      cost: null,
      accreditations: "",
      licenses: "",
      subOpCategory: "",
      opCategory: "Food",
      requiredDocuments: "Driver's license, proof of current address.",
      paymentsAccepted: "",
      eligibilities:
        "OPEN DURING COVID-19: Open to Everman city residents and families that have children attending the Everman ISD;\rAssistance given once every six months per household. ",
      fundings: "",
      serviceAreas: "City of Everman",
      languages: "English",
      draft: null,
      isPublished: null,
      createdAt: null,
      updatedAt: null,
      overallCapacity: null,
      currentlyServing: null,
      autoScreen: null,
      program: null,
      organization: null,
      location: null,
      contacts: null,
      phones: null,
      referrals: null,
    },
  ]);

  const [initiatives] = useState([
    {
      id: "82190d37-752b-4e10-b717-bdf4aa8e786b",
      serviceId: "24fc6d24-a693-40c0-a802-14b5fb2c774e",
      organizationId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
      name: "Bravo Food Bank",
      description:
        "We are a group of organizations involved in fighting food insecurity, providing nutritous meals to people who are in need and we are committed to ending hunger in our communities.",
      address: "",
      images: [],
      joinDate: 1705708800000,
      service: {
        id: "24fc6d24-a693-40c0-a802-14b5fb2c774e",
        orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
        name: "1st Wed Mobile Food Pantry",
        status: "Currently serving",
        alternateName: "",
        description: "Take children out of terrible households.",
        url: "",
        email: "liberator@bravotango.com",
        interpretationServices: "Spanish to English",
        applicationProcess: "Fill referral form",
        waitTime: "None, we work with available case workers.",
        cost: "None",
        accreditations: "",
        licenses: "",
        subOpCategory: "Adoption & Foster Care",
        opCategory: "care",
        requiredDocuments: "",
        paymentsAccepted: "No payments",
        eligibilities: "infants, teenagers, orphan, homeless, nearHomeless",
        fundings: "Donations",
        serviceAreas: "Texas, looking to expand",
        languages: "English",
        draft: false,
        isPublished: true,
        createdAt: 1715860378536,
        updatedAt: 1715860378536,
        overallCapacity: 400,
        currentlyServing: 109,
        autoScreen: false,
      },
    },
  ]);

  const [initiative] = useState({
    id: "82190d37-752b-4e10-b717-bdf4aa8e786b",
    serviceId: "24fc6d24-a693-40c0-a802-14b5fb2c774e",
    organizationId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
    name: "Bravo Food Bank",
    description:
      "We are a group of organizations involved in fighting food insecurity, providing nutritous meals to people who are in need and we are committed to ending hunger in our communities.",
    address: "",
    images: [],
    joinDate: null,
    service: {
      id: "24fc6d24-a693-40c0-a802-14b5fb2c774e",
      orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
      name: "1st Wed Mobile Food Pantry",
      status: "Currently serving",
      alternateName: "",
      description: "Take children out of terrible households.",
      url: "",
      email: "liberator@bravotango.com",
      interpretationServices: "Spanish to English",
      applicationProcess: "Fill referral form",
      waitTime: "None, we work with available case workers.",
      cost: "None",
      accreditations: "",
      licenses: "",
      subOpCategory: "Adoption & Foster Care",
      opCategory: "care",
      requiredDocuments: "",
      paymentsAccepted: "No payments",
      eligibilities: "infants, teenagers, orphan, homeless, nearHomeless",
      fundings: "Donations",
      serviceAreas: "Texas, looking to expand",
      languages: "English",
      draft: false,
      isPublished: true,
      createdAt: 1715860378536,
      updatedAt: 1715860378536,
      overallCapacity: 400,
      currentlyServing: 109,
      autoScreen: false,
    },
    // organizations: [
    //   {
    //     id: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
    //     description:
    //       "We are committed to the native and indigenous women, helping them get opportunities that should be utilized, securing jobs, training, scholarships and healthcare.",
    //     name: "Atewo Women",
    //     tagline: "The native crown",
    //     alternateName: "Building a sure foundation for women in the locality.",
    //     email: "tarablake@email.co",
    //     url: "https://atewowomen.org",
    //     ein: null,
    //     deductibility: null,
    //     subsection: null,
    //     assetAmount: null,
    //     nteeType: "Community Improvement, Capacity Building",
    //     incomeAmount: null,
    //     nteeSuffix: "81",
    //     filingRequirement: null,
    //     classification: null,
    //     latest990: null,
    //     rulingDate: null,
    //     nteeCode: "S81",
    //     groupName: null,
    //     deductibilityCode: null,
    //     affiliation: null,
    //     foundationStatus: null,
    //     nteeClassification: "Women's Service Clubs",
    //     accountingPeriod: null,
    //     exemptOrgStatus: null,
    //     deductibilityDetail: null,
    //     exemptOrgStatusCode: null,
    //     subOpCategory: "Skills & Training",
    //     opCategory: "work",
    //     nteeLetter: "S",
    //     reviews: null,
    //     rating: null,
    //     logoUrl: null,
    //   },
    //   {
    //     id: "559b5ffb-6b56-4169-9b33-478e6b938264",
    //     description:
    //       "We run foster services, taking in children on the streets and in abusive homes. It has been certified that such environments build adults that are a menace to society, and we hope to reduce this occurence.",
    //     name: "Bravo Tango",
    //     tagline: "Building a better future",
    //     alternateName: "",
    //     email: "contact@bravotango.com",
    //     url: "https://bravotango.com",
    //     ein: null,
    //     deductibility: null,
    //     subsection: null,
    //     assetAmount: null,
    //     nteeType: "Human Services",
    //     incomeAmount: null,
    //     nteeSuffix: "32",
    //     filingRequirement: null,
    //     classification: null,
    //     latest990: null,
    //     rulingDate: null,
    //     nteeCode: "P32",
    //     groupName: null,
    //     deductibilityCode: null,
    //     affiliation: null,
    //     foundationStatus: null,
    //     nteeClassification: "Foster Care",
    //     accountingPeriod: null,
    //     exemptOrgStatus: null,
    //     deductibilityDetail: null,
    //     exemptOrgStatusCode: null,
    //     subOpCategory: "Adoption & Foster Care",
    //     opCategory: "care",
    //     nteeLetter: "P",
    //     reviews: null,
    //     rating: null,
    //     logoUrl: null,
    //   },
    // ],
  });

  const [referrals] = useState([
    {
      id: "0f7d74ac-fded-4859-99b7-48924e6c4d13",
      from: "ssn",
      userId: "64e8d87d1e6a8500022bcb51",
      eligibilityStatus: true,
      serviceId: "396eeddf-bd8d-4485-8ca5-0dfd163a745e",
      serviceName: "History",
      service: {
        opCategory: "Domestic Assistance",
        subOpCategory: "emergency housing support",
      },
      orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
      status: "approved",
      isSelfReferral: false,
      user: {
        id: "65fb26d9e9cf0b00020207d4",
        firstName: "June",
        lastName: "Adamns",
        country: null,
        avatarUrl: null,
        isDeleted: null,
        email: "adamsjune@gmail.com",
        gender: null,
        employmentStatus: null,
        disability: null,
        dob: null,
        housingStatus: null,
        incomeLevel: null,
        insurance: null,
        household: null,
        createdAt: null,
        updatedAt: null,
        phone: null,
        ext: null,
        verified: null,
      },
    },
    {
      id: "4b2a74eb-e3fc-4e1f-bccb-2221578d54ef",
      from: "ssn",
      userId: "65f9b94777b0800002001c04",
      eligibilityStatus: true,
      serviceId: "396eeddf-bd8d-4485-8ca5-0dfd163a745e",
      serviceName: "History and Culture Training",
      orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
      status: "approved",
      isSelfReferral: true,
      service: {
        opCategory: "Care",
        subOpCategory: "Aninmal Welfare",
      },
      user: {
        id: "65f9b94777b0800002001c04",
        firstName: "Bee",
        lastName: "Neton",
        country: null,
        avatarUrl: null,
        isDeleted: null,
        email: "beeneton@email.co",
        gender: null,
        employmentStatus: null,
        disability: null,
        dob: null,
        housingStatus: null,
        incomeLevel: null,
        insurance: null,
        household: null,
        createdAt: null,
        updatedAt: null,
        phone: null,
        ext: null,
        verified: null,
      },
    },
    {
      id: "f4445b3a-1026-46ec-91e0-7d1012f07558",
      from: "ssn",
      userId: "65fb26d9e9cf0b00020207d4",
      eligibilityStatus: true,
      serviceId: "396eeddf-bd8d-4485-8ca5-0dfd163a745e",
      serviceName: "History",
      orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
      status: "pending",
      isSelfReferral: false,
      service: {
        opCategory: "Education",
        subOpCategory: "Skills and Training",
      },
      user: {
        id: "65fb3240e9cf0b00020207e3",
        firstName: "Paul",
        lastName: "Holland",
        country: null,
        avatarUrl: null,
        isDeleted: null,
        email: "paul.holland@gmail.com",
        gender: null,
        employmentStatus: null,
        disability: null,
        dob: null,
        housingStatus: null,
        incomeLevel: null,
        insurance: null,
        household: null,
        createdAt: null,
        updatedAt: null,
        phone: null,
        ext: null,
        verified: null,
      },
    },

    {
      id: "7fae82ae-1f06-4c8f-90ca-cbef561e9bfd",
      from: "ssn",
      userId: "62e9bd187de07a000411c70a",
      eligibilityStatus: false,
      serviceId: "396eeddf-bd8d-4485-8ca5-0dfd163a745e",
      serviceName: "History and Culture Training",
      orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
      status: "rejected",
      isSelfReferral: false,
      service: {
        opCategory: "Care",
        subOpCategory: "Aninmal Welfare",
      },
      user: {
        id: "65fd6fbebfd74b00028988ae",
        firstName: "Ignatius",
        lastName: "Gino",
        country: null,
        avatarUrl: null,
        isDeleted: null,
        email: "vasimo7965@otemdi.com",
        gender: null,
        employmentStatus: null,
        disability: null,
        dob: null,
        housingStatus: null,
        incomeLevel: null,
        insurance: null,
        household: null,
        createdAt: null,
        updatedAt: null,
        phone: null,
        ext: null,
        verified: null,
      },
    },
    {
      id: "a2420406-da47-404b-ae15-d89ab63ba475",
      from: "ssn",
      userId: "62e9bd187de07a000411c70a",
      eligibilityStatus: false,
      serviceId: "396eeddf-bd8d-4485-8ca5-0dfd163a745e",
      serviceName: "History and Culture Training",
      orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
      status: "approved",
      isSelfReferral: false,
      service: {
        opCategory: "Education",
        subOpCategory: "Skills and Training",
      },
      user: {
        id: "66019ba4e09d300002130f55",
        firstName: "Vasimoto",
        lastName: "Yokohama",
        country: null,
        avatarUrl: null,
        isDeleted: null,
        email: "vasim765@otemdi.com",
        gender: null,
        employmentStatus: null,
        disability: null,
        dob: null,
        housingStatus: null,
        incomeLevel: null,
        insurance: null,
        household: null,
        createdAt: null,
        updatedAt: null,
        phone: null,
        ext: null,
        verified: null,
      },
    },
    {
      id: "63fa1337-a71f-4993-b7d4-2e1ad2858ad3",
      from: "ssn",
      userId: "62e9bd187de07a000411c70a",
      eligibilityStatus: false,
      serviceId: "396eeddf-bd8d-4485-8ca5-0dfd163a745e",
      serviceName: "History and Culture Training",
      orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
      status: "pending",
      isSelfReferral: false,
      service: {
        opCategory: "Food",
        subOpCategory: "Help pay for food",
      },
      user: {
        id: "660c3d723b34490002b2b279",
        firstName: "Malory",
        lastName: "Wiston",
        country: null,
        avatarUrl: null,
        isDeleted: null,
        email: "nurzacorzi@gufum.com",
        gender: null,
        employmentStatus: null,
        disability: null,
        dob: null,
        housingStatus: null,
        incomeLevel: null,
        insurance: null,
        household: null,
        createdAt: null,
        updatedAt: null,
        phone: null,
        ext: null,
        verified: null,
      },
    },
    {
      id: "78a889e1-7792-433b-9960-61ef4dbe7f68",
      from: "ssn",
      userId: "62e9bd187de07a000411c70a",
      eligibilityStatus: false,
      serviceId: "396eeddf-bd8d-4485-8ca5-0dfd163a745e",
      serviceName: "History and Culture Training",
      orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
      status: "approved",
      isSelfReferral: false,
      service: {
        opCategory: "Food",
        subOpCategory: "Help pay for food",
      },
      user: {
        id: "660c3f5d3b34490002b2b27c",
        firstName: "Axle",
        lastName: "Walter",
        country: null,
        avatarUrl: null,
        isDeleted: null,
        email: "fazjl6je8x@waterisgone.com",
        gender: null,
        employmentStatus: null,
        disability: null,
        dob: null,
        housingStatus: null,
        incomeLevel: null,
        insurance: null,
        household: null,
        createdAt: null,
        updatedAt: null,
        phone: null,
        ext: null,
        verified: null,
      },
    },
  ]);

  const [impactMetrics] = useState({
    data: {
      getImpactMetrics: {
        numberOfReferralByOrgId: 7,
        numberOfCasesByOrgId: 5,
        numberOfServicesByOrgId: 6,
        numberOfClosedCasesByOrgId: 0,
        numberOfAcceptedCasesByOrgId: 0,
      },
    },
  });

  const [cases] = useState([
    {
      id: "94a957be-a2b5-48e5-bebe-3327b7ea8744",
      caseNumber: "CN-C8JPM",
      orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
      status: "open",
      createdAt: 1710938883037,
      updatedAt: 1710938883037,
      referral: {
        id: "4b2a74eb-e3fc-4e1f-bccb-2221578d54ef",
        from: "ssn",
        userId: "65f9b94777b0800002001c04",
        eligibilityStatus: true,
        serviceId: "396eeddf-bd8d-4485-8ca5-0dfd163a745e",
        serviceName: "History and Culture Training",
        orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
        status: "approved",
        isSelfReferral: true,
      },
    },
    {
      id: "dabb0da0-3d8c-4e3f-aea6-66170f17649d",
      caseNumber: "CN-C8JPM",
      orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
      status: "open",
      createdAt: 1710958460843,
      updatedAt: 1710958460843,
      referral: {
        id: "0f7d74ac-fded-4859-99b7-48924e6c4d13",
        from: "ssn",
        userId: "64e8d87d1e6a8500022bcb51",
        eligibilityStatus: true,
        serviceId: "396eeddf-bd8d-4485-8ca5-0dfd163a745e",
        serviceName: "History",
        orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
        status: "approved",
        isSelfReferral: false,
      },
    },
    {
      id: "da6ccf01-e89b-4310-b31a-7230b148d498",
      caseNumber: "CN-C8JPM",
      orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
      status: "open",
      createdAt: 1710961275609,
      updatedAt: 1710961275609,
      referral: {
        id: "f4445b3a-1026-46ec-91e0-7d1012f07558",
        from: "ssn",
        userId: "65fb26d9e9cf0b00020207d4",
        eligibilityStatus: true,
        serviceId: "396eeddf-bd8d-4485-8ca5-0dfd163a745e",
        serviceName: "History",
        orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
        status: "approved",
        isSelfReferral: false,
      },
    },
    {
      id: "93805a1b-6943-4d6b-bdb8-76f4c1000c50",
      caseNumber: "CN-EXL2T",
      orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
      status: "open",
      createdAt: 1722515254718,
      updatedAt: 1722515254718,
      referral: {
        id: "78a889e1-7792-433b-9960-61ef4dbe7f68",
        from: "ssn",
        userId: "62e9bd187de07a000411c70a",
        eligibilityStatus: false,
        serviceId: "396eeddf-bd8d-4485-8ca5-0dfd163a745e",
        serviceName: "History and Culture Training",
        orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
        status: "approved",
        isSelfReferral: false,
      },
    },
    {
      id: "39c2711a-df53-4240-ae5e-549c6a16e639",
      caseNumber: "CN-OL6WR",
      orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
      status: "open",
      createdAt: 1730894382563,
      updatedAt: 1730894382563,
      referral: {
        id: "a2420406-da47-404b-ae15-d89ab63ba475",
        from: "ssn",
        userId: "62e9bd187de07a000411c70a",
        eligibilityStatus: false,
        serviceId: "396eeddf-bd8d-4485-8ca5-0dfd163a745e",
        serviceName: "History and Culture Training",
        orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
        status: "approved",
        isSelfReferral: false,
      },
    },
  ]);

  const [orgAnalyticsData] = useState({
    getOrgAnalytics: {
      id: "d24028c1-d1ce-4d5c-ad81-542558e66495",
      orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
      numberOfViews: 11,
      numberOfSaves: 1,
      numberOfRefers: 1,
      numberOfSuggestEdits: 0,
      suggestEditsBy: [],
      viewsDates: [
        1710867549684, 1710867599780, 1710867604443, 1710867812816, 1710868004379,
        1710938796104, 1710938802812, 1710960899616, 1710960928635, 1710960942783,
        1719361641383,
      ],
      saveDates: [1710867604443],
      referDates: [1710868004379],
      suggestEditsDates: [],
    },
  });

  const [requests] = useState([
    {
      id: "d91ec4ac-449b-42d1-8528-f3f3c7165306",
      initiativeId: "8fa0c692-1b95-4c22-8e5a-17f7c6cc4fe3",
      organizationId: "baca9f34-cdb2-4c38-a719-938d68ced9e1",
      status: "rejected",
      createdAt: 1715152646259,
      initiativeOwnerId: "77154092-4c3f-45f5-86bc-9e037ec22cfc",
      initiativeAddress: "Alabama",
      initiativeName: "Steel Homes",
    },
    {
      id: "d91ec4ac-449b-42d1-8528-f3f3c7165308",
      initiativeId: "8fa0c692-1b95-4c22-8e5a-17f7c6cc4fs4",
      organizationId: "baca9f34-cdb2-4c38-a719-938d68ced9e1",
      status: "pending",
      createdAt: 1715152646259,
      initiativeOwnerId: "77154092-4c3f-45f5-86bc-9e037ec22cfe",
      initiativeAddress: "Floria",
      initiativeName: "Food Security",
    },
  ]);

  const [invites] = useState([
    {
      id: "90758a2e-e9db-448d-a60b-92b4dabe2a1e",
      initiativeId: "4cc8e745-734a-4eb8-a922-ac183c671d7d",
      invitedOrganizationId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
      status: "pending",
      createdAt: 1740135693695,
      organization: {
        name: "Tee Labs",
      },
      initiative: {
        id: "4cc8e745-734a-4eb8-a922-ac183c671d7d",
        serviceId: "3f99abf5-6967-4505-82f1-bcb317242d60",
        organizationId: "df1b7c31-7185-428d-b67a-7d7fcae42d39",

        name: "The Child Food Initiative",
        description: "Child food initiative",
        address: null,
        images: [],
        joinDate: null,
      },
    },
  ]);

  const [pendingReferrals] = useState([
    {
      id: "2748e444-6bef-4e83-a9d1-c372b64c5508",
      from: "ssn",
      userId: "67656afd078e300002b5b180",
      eligibilityStatus: false,
      serviceId: "3f99abf5-6967-4505-82f1-bcb317242d60",
      serviceName: "Bravo Liberator",
      orgId: "df1b7c31-7185-428d-b67a-7d7fcae42d39",
      status: "pending",
      isSelfReferral: false,
      user: {
        firstName: "Mike",
        lastName: "Fields",
        email: "michael@gmail.com",
        country: null,
        __typename: "SSNUser",
      },
      __typename: "Referral",
    },
  ]);

  const [approvedReferrals] = useState([
    {
      id: "2748e444-6bef-4e83-a9d1-c372b64c5588",
      from: "ssn",
      userId: "67656afd078e300002b5b180",
      eligibilityStatus: false,
      serviceId: "3f99abf5-6967-4505-82f1-bcb317242d60",
      serviceName: "Bravo Liberator",
      orgId: "df1b7c31-7185-428d-b67a-7d7fcae42d39",
      status: "approved",
      isSelfReferral: false,
      user: {
        firstName: "Denice",
        lastName: "Gillian",
        email: "dgillian@gmail.com",
        country: null,
        __typename: "SSNUser",
      },
      __typename: "Referral",
    },

    {
      id: "2748e444-6bef-4e83-a9d1-c372b64c5598",
      from: "ssn",
      userId: "67656afd078e300002b5b180",
      eligibilityStatus: false,
      serviceId: "3f99abf5-6967-4505-82f1-bcb317242d60",
      serviceName: "Bravo Liberator",
      orgId: "df1b7c31-7185-428d-b67a-7d7fcae42d39",
      status: "approved",
      isSelfReferral: false,
      user: {
        firstName: "Clark",
        lastName: "Boyce",
        email: "theoldboys@gmail.com",
        country: null,
        __typename: "SSNUser",
      },
      __typename: "Referral",
    },
  ]);

  const [rejectedReferrals] = useState([
    {
      id: "2748e444-6bef-4e83-a9d1-c372b64c5548",
      from: "ssn",
      userId: "67656afd078e300002b5b180",
      eligibilityStatus: false,
      serviceId: "3f99abf5-6967-4505-82f1-bcb317242d60",
      serviceName: "Bravo Liberator",
      orgId: "df1b7c31-7185-428d-b67a-7d7fcae42d39",
      status: "rejected",
      isSelfReferral: false,
      user: {
        firstName: "Jon",
        lastName: "Doe",
        email: "jondoe@email.com",
        country: null,
        __typename: "SSNUser",
      },
      __typename: "Referral",
    },
  ]);

  const [allInitiativeReferrals] = useState([
    {
      id: "2748e444-6bef-4e83-a9d1-c372b64c5548",
      from: "ssn",
      userId: "67656afd078e300002b5b180",
      eligibilityStatus: false,
      serviceId: "3f99abf5-6967-4505-82f1-bcb317242d60",
      serviceName: "Bravo Liberator",
      orgId: "df1b7c31-7185-428d-b67a-7d7fcae42d39",
      status: "rejected",
      isSelfReferral: false,
      user: {
        firstName: "Jon",
        lastName: "Doe",
        email: "jondoe@email.com",
        age: "28",
        gender: "Male",
        household: "Large Family",
        insurance: "Under Insured",
        incomeLevel: "Low Income",
        employmentStatus: "Employed",
        housingStatus: "Not Homeless",
        country: null,
        __typename: "SSNUser",
      },
      __typename: "Referral",
    },
    {
      id: "2748e444-6bef-4e83-a9d1-c372b64c5508",
      from: "ssn",
      userId: "67656afd078e300002b5b180",
      eligibilityStatus: false,
      serviceId: "3f99abf5-6967-4505-82f1-bcb317242d60",
      serviceName: "Bravo Liberator",
      orgId: "df1b7c31-7185-428d-b67a-7d7fcae42d39",
      status: "pending",
      isSelfReferral: false,
      user: {
        firstName: "Mike",
        lastName: "Fields",
        email: "michael@gmail.com",
        country: null,
        age: "18",
        gender: "Male",
        household: "Individual",
        insurance: "Under Insured",
        incomeLevel: "Low Income",
        employmentStatus: "Employed",
        housingStatus: "Not Homeless",
        __typename: "SSNUser",
      },
      __typename: "Referral",
    },
    {
      id: "2748e444-6bef-4e83-a9d1-c372b64c5588",
      from: "ssn",
      userId: "67656afd078e300002b5b180",
      eligibilityStatus: false,
      serviceId: "3f99abf5-6967-4505-82f1-bcb317242d60",
      serviceName: "Bravo Liberator",
      orgId: "df1b7c31-7185-428d-b67a-7d7fcae42d39",
      status: "approved",
      isSelfReferral: false,
      user: {
        firstName: "Denice",
        lastName: "Gillian",
        email: "dgillian@gmail.com",
        country: null,
        gender: "Female",
        age: "22",
        household: "Individual",
        insurance: "Under Insured",
        incomeLevel: "Low Income",
        employmentStatus: "Employed",
        housingStatus: "Not Homeless",
        __typename: "SSNUser",
      },
      __typename: "Referral",
    },

    {
      id: "2748e444-6bef-4e83-a9d1-c372b64c5598",
      from: "ssn",
      userId: "67656afd078e300002b5b180",
      eligibilityStatus: false,
      serviceId: "3f99abf5-6967-4505-82f1-bcb317242d60",
      serviceName: "Bravo Liberator",
      orgId: "df1b7c31-7185-428d-b67a-7d7fcae42d39",
      status: "approved",
      isSelfReferral: false,
      user: {
        firstName: "Clark",
        lastName: "Boyce",
        email: "theoldboys@gmail.com",
        country: null,
        gender: "Male",
        age: "30",
        household: "Small Family",
        insurance: "Not Insured",
        incomeLevel: "Low Income",
        employmentStatus: "Unemployed",
        housingStatus: "Near Homeless",
        __typename: "SSNUser",
      },
      __typename: "Referral",
    },
  ]);

  const [eligibilities] = useState([
    {
      id: "7e476548-8480-48f3-8941-36f5a3cc2b19",
      orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
      situation: "widow,nearHomeless",
      autoScreen: true,
      service: {
        name: "#IDareYouToCare, Mon - Fri Food Pantry",
      },
    },
  ]);

  const [referralForms] = useState([
    {
      id: "74487c1a-2dc8-4892-9540-3ee1d6110fa3",
      url: "https://organizations.socialsafety.net/referral-form/0dfd163a745e",
      createdBy: "62e9bd187de07a000411c70a",
      orgId: "a69c754c-c1d6-4ac1-9687-3e58e9b6324f",
      service: {
        name: "History and Culture Training",
        id: "396eeddf-bd8d-4485-8ca5-0dfd163a745e",
      },
      formFields:
        '[{"type":"number","required":false,"label":"Your Mobile Number","placeholder":"+1 (0) 000000","className":"form-control","name":"number-1710871038678-0","access":false},{"type":"date","required":true,"label":"Date of birth","className":"form-control","name":"date-1710871014440-0","access":false},{"type":"radio-group","required":false,"label":"Are you able to visit the office?","description":"We hold physical events, it would be good to have you around.","inline":false,"name":"radio-group-1710871082944-0","access":false,"other":false,"values":[{"label":"Yes","value":"yes","selected":false},{"label":"No","value":"no","selected":false}]},{"type":"textarea","required":true,"label":"Address","placeholder":"Your home address","className":"form-control","name":"textarea-1710961967328-0","access":false,"subtype":"textarea"},{"type":"file","required":false,"label":"Welfare Certificate","className":"form-control","name":"file-1710962011041-0","access":false,"subtype":"file","multiple":false}]',
      createdAt: 1710871523676,
      updatedAt: 1710962040833,
      status: "publish",
      numberOfSubmissions: 21,
    },
  ]);

  return (
    <demoContext.Provider
      value={{
        token,
        orgId,
        organization,
        services,
        initiatives,
        referrals,
        impactMetrics,
        orgAnalyticsData,
        cases,
        initiative,
        requests,
        invites,
        pendingReferrals,
        approvedReferrals,
        rejectedReferrals,
        allInitiativeReferrals,
        eligibilities,
        referralForms,
      }}
    >
      {props.children}
    </demoContext.Provider>
  );
};
